import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AspCustomerDetailsComponent } from './asp-customer-details.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

const routes:Routes = [
  {
      path: 'customer-details/:ph/:id',
      component: AspCustomerDetailsComponent,
  },
];

@NgModule({
  declarations: [AspCustomerDetailsComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    MatIconModule,
    MatCardModule
  ]
})
export class AspCustomerDetailsModule { }
